export const capitalize = (str: string) => {
    const [firstLetter, ...rest] = str.split('');
    return [firstLetter.toLocaleUpperCase(), ...rest].join('');
};

export const isEqual = (value: unknown, other: unknown) => {
    if (typeof value === 'object' || typeof other === 'object') {
        return JSON.stringify(value) === JSON.stringify(other);
    } else {
        return value === other;
    }
};
